import React, { useEffect, useState } from 'react'
import MbuReportingGraph from './MbuReportingGraph';
import { useGetProjectGraphQuery, useLazyGetProjectGraphQuery } from '../../../services/EndPointsApis';
import { getToDateRanges } from '../../../core/common/GetDateRanges/GetDateRanges';
import { customStyles } from '../../../core/common/Custom Style/CustomStyle';
import Select from "react-select";
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import TableLoading from '../../../core/common/loadingComponent/TableLoading';
import { useDispatch } from 'react-redux';
import { setDateRangeMbu } from '../../../core/data/redux/commonSlice';
import MbuSalesGraph from './MbuSalesGraph';

const MbuReporting = () => {
    const [triggerGraphData, { data, isSuccess, isFetching }] = useLazyGetProjectGraphQuery();
    const [selectedDate, setselectedDate] = useState(null)
    const [selectedDropdown, setselectedDropdown] = useState({ label: "", value: 0 })
    const [selectedEnterpriseOption, setselectedEnterPriseOption] = useState({ value: 1, label: 'Project Developement' })
    const [selectedDateforParam, setselectedDateforParam] = useState({ startDate: '', endDate: '' })
    const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(null);
    const [displayMode, setDisplayMode] = useState<"count" | "volume">("count");
    const [viewMode, setViewMode] = useState<"chart" | "table">("chart");
    const dispatch = useDispatch()

    const ranges = getToDateRanges();
    const options = [
        { value: ranges.WTD, label: "Week to Date (WTD)" },
        { value: ranges.MTD, label: "Month to Date (MTD)" },
        { value: ranges.QTD, label: "Quarter to Date (QTD)" },
        { value: ranges.YTD, label: "Year to Date (YTD)" },
        { value: ranges.TTM, label: "Trailing Twelve Months (TTM)" },
        { value: 5, label: "Specify Time Frame" }
    ];
    const formattedDefaultStart = dayjs(ranges?.YTD?.start).format('YYYY-MM-DD');
    const formattedDefaultEnd = dayjs(ranges?.YTD?.end).format('YYYY-MM-DD');
    const [selectedLabel, setselectedLabel] = useState({ value: ranges.YTD, label: "Year to Date (YTD)" })


    const { RangePicker } = DatePicker;

    const AntdDateRangePicker = ({
        value,
        onChange,
        onRangeChange
    }: {
        value: [dayjs.Dayjs, dayjs.Dayjs] | null;
        onChange: (val: [dayjs.Dayjs, dayjs.Dayjs] | null) => void;
        onRangeChange: (range: { startDate: string; endDate: string }) => void;
    }) => {
        const handleChange = (values: any) => {
            onChange(values); // ⬅️ Update parent state

            if (values && values[0] && values[1]) {
                onRangeChange({
                    startDate: values[0].format('MMM-DD-YYYY'),
                    endDate: values[1].format('MMM-DD-YYYY'),
                });
            }
        };

        return (
            <div className="w-35">
                <RangePicker
                    value={value}
                    onChange={handleChange}
                    format="MMM-DD-YYYY"
                    allowClear
                    placeholder={['Start date', 'End date']}
                    style={{ width: '100%', height: '43px' }}
                />
            </div>
        );
    };

    const handleRangeChange = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
        triggerGraphData({ StartDate: startDate, EndDate: endDate });
        setselectedDateforParam({ startDate: startDate, endDate: endDate })

    }

    useEffect(() => {
        triggerGraphData({ StartDate: formattedDefaultStart, EndDate: formattedDefaultEnd });
    }, [])

    useEffect(() => {
        setselectedDateforParam({ startDate: formattedDefaultStart, endDate: formattedDefaultEnd })
    }, [])

    return (
        <div className="page-wrapper w-100">
            <div className="content">
                <div className="row ">
                    <div className="col-md-12 d-flex">
                        <div className='card w-100'>
                            <div className='card-body '>
                                <div className='d-flex gap-3 align-items-center px-3'>
                                    <p className='mb-0'>Enterprise - {selectedEnterpriseOption?.label}</p>
                                    <div className='w-25'>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            placeholder='Select'
                                            options={[
                                                { label: "Project Development", value: 1 },
                                                { label: "Field Production", value: 2 },
                                                { label: "Sales", value: 3 }

                                            ]}
                                            value={selectedEnterpriseOption}
                                            onChange={(selectedOption: any) => {
                                                setselectedEnterPriseOption(selectedOption)
                                                setselectedDropdown(selectedOption)
                                                triggerGraphData({ StartDate: formattedDefaultStart, EndDate: formattedDefaultEnd, isSale: selectedOption?.value === 3 ? true : false });
                                            }
                                            } />
                                    </div>
                                    <div className='w-25'>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            placeholder='Select'
                                            options=
                                            {
                                                options.map((opt, i) => (
                                                    {
                                                        label: opt?.label,
                                                        value: opt?.value
                                                    }))
                                            }
                                            value={selectedLabel}
                                            onChange={(selectedOption: any) => {
                                                setselectedDate(selectedOption?.value)
                                                setselectedLabel(selectedOption)
                                                if (selectedOption?.value?.start && selectedOption?.value?.end) {
                                                    const formattedDatestart = dayjs(selectedOption?.value.start).format('YYYY-MM-DD');
                                                    const formattedDateend = dayjs(selectedOption?.value.end).format('YYYY-MM-DD');
                                                    setselectedDateforParam({ startDate: formattedDatestart, endDate: formattedDateend })
                                                    triggerGraphData({ StartDate: formattedDatestart, EndDate: formattedDateend, isSale: selectedDropdown?.value === 3 ? true : false });
                                                }
                                            }}
                                        />
                                    </div>
                                    {selectedDate === 5 &&
                                        <div className='w-50'>
                                            <AntdDateRangePicker
                                                value={dateRange}
                                                onChange={setDateRange}
                                                onRangeChange={handleRangeChange}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className='d-flex mt-3 px-3'>
                                    <div className="col-md-2">
                                        <div className="radio-wrap">
                                            <div className="d-flex flex-wrap">
                                                <div className="radio-btn">
                                                    <input
                                                        className="status-radio"
                                                        id='chart'
                                                        type="radio"
                                                        value="chart"
                                                        checked={viewMode === "chart"}
                                                        onChange={() => setViewMode("chart")}
                                                    />
                                                    <label htmlFor="chart">Chart</label>
                                                </div>
                                                <div className="radio-btn">
                                                    <input
                                                        className="status-radio"
                                                        id="table"
                                                        type="radio"
                                                        value="table"
                                                        checked={viewMode === "table"}
                                                        onChange={() => setViewMode("table")}
                                                    />
                                                    <label htmlFor="table">Table</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="radio-wrap">
                                            <div className="d-flex flex-wrap">
                                                <div className="radio-btn">
                                                    <input
                                                        className="status-radio"
                                                        id='count'
                                                        type="radio"
                                                        name="displayMode"
                                                        value="count"
                                                        checked={displayMode === "count"}
                                                        onChange={() => setDisplayMode("count")}
                                                    />
                                                    <label htmlFor="count">Count</label>
                                                </div>
                                                <div className="radio-btn">
                                                    <input
                                                        className="status-radio"
                                                        id="volume"
                                                        type="radio"
                                                        name="displayMode"
                                                        value="volume"
                                                        checked={displayMode === "volume"}
                                                        onChange={() => setDisplayMode("volume")}
                                                    />
                                                    <label htmlFor="volume">Volume</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isFetching ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
                                        <TableLoading />
                                    </div>
                                ) : isSuccess && data?.result?.length > 0 ? (
                                    <div className='row mt-5'>
                                        <div className={`${selectedEnterpriseOption?.value !== 1 ? 'col-md-7 p-0' : "col-md-10 p-0"}`}>

                                            {selectedEnterpriseOption?.value !== 3 ?
                                                <>
                                                    <div className='text-center mt-3'>
                                                        <h5>Enterprise - {selectedEnterpriseOption?.label}</h5>
                                                    </div>
                                                    <div>
                                                        <MbuReportingGraph
                                                            data={data}
                                                            displayMode={displayMode}
                                                            viewMode={viewMode}
                                                            selectedDateforParam={selectedDateforParam}
                                                            selectedDate={selectedDate}
                                                            selectedEnterpriseOption={selectedEnterpriseOption}
                                                        />
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className='text-center mt-3'>
                                                        <h5>Enterprise - {selectedEnterpriseOption?.label}</h5>
                                                    </div>
                                                    <div>
                                                        <MbuSalesGraph
                                                            data={data}
                                                            displayMode={displayMode}
                                                            viewMode={viewMode}
                                                            selectedDateforParam={selectedDateforParam}
                                                            selectedDate={selectedDate}
                                                            
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                ) : null
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default MbuReporting